module.exports = __webpack_public_path__ + "static/media/on_demand_solutions.1fb6a48e.svg";